<template>
    <div class="ag-overlay-loading-center">
        <div class="loader-container">
            <div class="loader" />
        </div>
    </div>
</template>

<style scoped lang="scss" src="./style.scss">
</style>